import styled from "styled-components";
import DefaultAvatarImage from "../../../assets/images/default-avatar.jpg"

export const UserInformationWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: space-between;
    overflow-x: hidden;
    overflow-y: auto; 
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    padding: 12px 16px;
`;

export const UserInfoHeader = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;
    
    background-color: #f5f5f5;
    border-bottom: 1px solid #e8e8e8;
`;

export const Avatar = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    margin: 20px;
    border-radius: 50%;
    box-sizing: border-box;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${DefaultAvatarImage});
    box-shadow: 0 0 3px #000000;
`;

export const ProfileDetails = styled.div`
    display: flex; 
    flex-direction: column;
    align-items: stretch;
    padding-left: 12px;
    font-size: 14px;

    & .anticon {
        font-size: 14px;
        margin-right: 10px;
    }

    & > div {
        padding: 5px 0px;
    }
`;

export const TenantName = styled.div`
`;

export const Name = styled.div`
`;

export const PhoneNumber = styled.div`
`;

export const Email = styled.div`
`;

export const InfoWrapper = styled.span`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 24px 0px;
`;

export const Info = styled.span`
    font-size: 14px;
    margin-right: 8px;
    align-items: row;
    margin-top: 20px;
    padding-bottom: 8px; 
    border-bottom: 1px solid #EEEEEE; 
`;

export const InfoName= styled.span`
    font-size: 14px;
    margin-left:10px;
`;

export const InfoLabel= styled.span`
    font-size: 14px;
`;


export const Operation = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    padding: 12px 30px;
    box-sizing: border-box;
    font-weight: bold;
    font-size: 14px;
    border-top: 1px solid #EEEEEE;
    border-bottom: 1px solid #EEEEEE;
    border-bottom: 1px solid #EEEEEE;

    &:hover {
        background-color: rgba(0, 0, 0, 0.5);
        color: #FFFFFF;
    }
`;

